import { render } from "./DialogMessageShow.vue?vue&type=template&id=10b9e676"
import script from "./DialogMessageShow.vue?vue&type=script&lang=js"
export * from "./DialogMessageShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__